import { reportEvent } from '@stitch-fix/event-reporter/legacy';
import packageInfo from '../../../../../../../package.json';

const eventsServiceUrl = () => window.gon?.events_service_url;

const appName = packageInfo.name;

// Attempt to avoid unbounded metrics and retain existing monitors/dashboards
const filteredCollectionMetricTag = collection => {
  if (['kept-items', 'trending'].includes(collection)) {
    return collection;
  }

  return undefined;
};

// We have to pass in explicit attributes, otherwise "full_url" is set to the
// proxy API & "referer" is set to the page the client is on
const getNormalEventBody = event => {
  const {
    event_name: eventName,
    canonical_name: canonicalName,
    action_type: actionType,
    action_name: actionName,
    // Unused, but removes action detail from the rest spread
    action_detail: actionDetail,
    metrics_tags: metricsTags,
    ...directBuyContext
  } = event;

  return {
    event_name: eventName,
    canonical_name: canonicalName,
    action_type: actionType,
    action_detail: actionDetail,
    action_name: actionName,
    additional_context: { direct_buy: directBuyContext },
    full_url: window.location.href,
    referer: document.referrer,
    metrics_tags: {
      ...metricsTags,
      collection: filteredCollectionMetricTag(event.collection),
    },
    source_app: appName,
  };
};

const getPromoEventBody = event => {
  const {
    event_name: eventName,
    canonical_name: canonicalName,
    action_type: actionType,
    action_name: actionName,
    metrics_tags: metricsTags,
    ...eventContext
  } = event;

  return {
    event_name: eventName,
    canonical_name: canonicalName,
    action_type: actionType,
    action_name: actionName,
    additional_context: eventContext,
    full_url: window.location.href,
    referer: document.referrer,
    metrics_tags: {
      ...metricsTags,
      collection: filteredCollectionMetricTag(event.collection),
    },
    source_app: appName,
  };
};

const track = (event, { isPromo } = {}) => {
  const eventBody = isPromo
    ? getPromoEventBody(event)
    : getNormalEventBody(event);

  reportEvent({ event: eventBody, url: eventsServiceUrl() });
};

export default track;
